import { all, fork } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { watchAuthSagas } from 'src/features/auth';
import { watchHosLogsSagas } from 'src/features/hosLogs/store';
import { watchProfileSagas } from 'src/features/profile/store/profileSaga';
import { watchMovementSagas } from 'src/features/movements/store/movementSagas';
// import { calculateELDStateForData } from 'src/features/drivers';

export default function* rootSaga(): SagaIterator {
  yield all([fork(watchAuthSagas)]);
  yield all([fork(watchHosLogsSagas)]);
  yield all([fork(watchProfileSagas)]);
  yield all([fork(watchMovementSagas)]);
}
